/* eslint-disable react/display-name */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { Suspense, lazy, useCallback, useMemo } from 'react';
import { Switch, Route, Redirect, useHistory, useRouteMatch } from 'react-router-dom';
import { AppShell } from '@tapresearch/ui/components';
import { useMediaQuery } from '@tapresearch/ui/hooks';
import { LinkedInConversionTracker } from 'Shared/Tracking/LinkedInConversionTracker';
import { AccountMenu, CurrentUserLabel, useSidebarNav, useInactivePublisher, OrganizationalContextBanner } from 'Shared/SiteNav';
import { HeaderContent } from './HeaderContent';
import Startup from './Startup';
var Help = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'help' */ '../components/help');
});
var Projects = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'projects' */ '../components/project/Projects');
});
var Project = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'project' */ '../components/project/index');
});
var Campaign = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'campaign' */ '../components/campaign/index');
});
var Tracker = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'tracker' */ '../components/tracker');
});
export default function InsightsPlatformLoader(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ React.createElement(Startup, props, /*#__PURE__*/ React.createElement(LinkedInConversionTracker, null), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement("div", null)
    }, /*#__PURE__*/ React.createElement(AppShellContainer, {
        user: props.currentUser,
        assets: props.assets
    })));
}
var AppShellContainer = function(param) {
    var user = param.user, assets = param.assets;
    var history = useHistory();
    var _useMediaQuery = _sliced_to_array(useMediaQuery('(max-width: 1200px)'), 1), isSmall = _useMediaQuery[0];
    var role = (user && user.organization_membership || {}).role;
    var isInactivePublisher = useInactivePublisher(user);
    var onNavigate = useCallback(function(path) {
        var internal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (internal) return history.push(path);
        window.location.href = path;
    }, [
        history
    ]);
    var isLinkActive = {
        surveys: true
    };
    var isHomepage = useRouteMatch({
        path: [
            '/'
        ],
        exact: true
    });
    var sideNavItems = useSidebarNav({
        user: user,
        onNavigate: onNavigate,
        isLinkActive: isLinkActive,
        internal: 'insights_platform',
        constants: assets.constants,
        isInactivePublisher: isInactivePublisher
    });
    var sidebarTopSection = useMemo(function() {
        return user && user.is_ops && role === assets.constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS && /*#__PURE__*/ React.createElement(OrganizationalContextBanner, {
            organizationName: user.organization.company_name
        });
    }, [
        assets,
        role,
        user
    ]);
    return /*#__PURE__*/ React.createElement(AppShell, {
        padding: "xs",
        userMenuLabel: /*#__PURE__*/ React.createElement(CurrentUserLabel, {
            user: user,
            constants: assets.constants
        }),
        userMenuContent: /*#__PURE__*/ React.createElement(AccountMenu, {
            user: user,
            asset: assets
        }),
        sideNavItems: sideNavItems,
        sidebarTopSection: sidebarTopSection,
        headerContent: /*#__PURE__*/ React.createElement(HeaderContent, {
            isHomepage: isHomepage
        }),
        noSidebarToggle: !isHomepage,
        isFullscreen: !isHomepage,
        innerShellProps: _object_spread({}, !isHomepage && {
            maxWidth: '1300px',
            margin: '0 auto'
        }),
        headerProps: {
            sx: {
                position: isSmall ? 'sticky' : 'fixed',
                marginLeft: isSmall && !!isHomepage ? 'var(--mantine-navbar-width,0)' : 0
            }
        },
        sx: {
            minWidth: '1200px',
            main: _object_spread({}, isSmall && {
                paddingTop: '1rem'
            })
        }
    }, /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(Redirect, {
        exact: true,
        from: "/dashboard/projects/:projectIdentifier/campaigns/:campaignIdentifier",
        to: "/projects/:projectIdentifier/campaigns/:campaignIdentifier"
    }), /*#__PURE__*/ React.createElement(Redirect, {
        exact: true,
        from: "/dashboard/projects/:projectIdentifier/dashboard",
        to: "/projects/:projectIdentifier/dashboard"
    }), /*#__PURE__*/ React.createElement(Redirect, {
        exact: true,
        from: "*/projects/:projectIdentifier",
        to: "/projects/:projectIdentifier/dashboard"
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "*/tracker",
        component: Tracker
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "*/help",
        component: Help
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "*/projects/:projectIdentifier/dashboard",
        component: Project
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "*/projects/:projectIdentifier/campaigns/:campaignIdentifier",
        component: Campaign
    }), /*#__PURE__*/ React.createElement(Redirect, {
        exact: true,
        from: "/dashboard",
        to: "/"
    }), /*#__PURE__*/ React.createElement(Route, {
        path: "/",
        component: Projects
    })));
};
